import { makeContext } from "@shared/utils/makeContext";
import { Quiz, QuizResponse } from "@platform/types/quiz.types";

// --- Name ---
const NAME = "Quiz";

// --- Types ---
export type QuizState = {
  responseId?: string;
  quizResponse?: QuizResponse;
  quiz?: Quiz;
};

export type Action = {
  type: string;
  payload: object;
};

// --- Constants ---
export const QUIZ_RESPONSE_SET = "quizResponse/set" as const;

export const ACTION_TYPES = {
  QUIZ_RESPONSE_SET,
} as const;

// --- Initial State ---
export const initialQuiz: QuizState = {};

// --- Reducer ---
function quizReducer(state: QuizState, action: Action): QuizState {
  switch (action.type) {
    case ACTION_TYPES.QUIZ_RESPONSE_SET:
      return {
        ...state,
        quizResponse: action.payload.quizResponse as QuizResponse,
        quiz: action.payload.quiz as Quiz,
      };
    default: {
      throw Error("Unknown action: " + action.type);
    }
  }
}

// --- Context Creation ---
export const {
  Provider: QuizProvider,
  useState: useQuiz,
  useDispatch: useQuizDispatch,
} = makeContext<QuizState, Action>({
  name: NAME,
  initialState: initialQuiz,
  reducer: quizReducer,
});
